function shuffleArray( array )
{

    let shuffledArray = [...array];

    let j, i, temp;

    for (i = shuffledArray.length - 1; i > 0; i--)
    {
        j = Math.floor(Math.random() * (i + 1));
        temp = shuffledArray[i];
        shuffledArray[i] = shuffledArray[j];
        shuffledArray[j] = temp;
    }

    return shuffledArray;
}

function shuffleLetters( word )
{
    const chars = word.split('');

    return shuffleArray( chars );
}

export function scrambleSentence( sentence )
{
    const splitSentence = sentence.split(" ");

    const scrambledSentenceArray = splitSentence.map( elem => shuffleLetters(elem).toString().replaceAll( ",", "" ) ) ;

    const scrambledSentence = scrambledSentenceArray.toString().replaceAll( ",", " " );

    return scrambledSentence;
}

export const capitalizeHead = string => 
{
    const head = string[0].toUpperCase();
    const tail = string.slice(1);

    return head + tail;
}

export const countStars = int => {
    let stars = "";
    for( let i = 0; i < int; i++)
    {
        stars += "☆";
    }
    return stars;
}

export const capitalizeHeads = entries => {

    let newEntries = [...entries];
    newEntries.forEach( (entry) => {
        entry[0] = capitalizeHead(entry[0]);
    });

    return newEntries;
}